module.exports = __webpack_public_path__ + "static/media/token_sport.b0bc4fd6.png";